import { useEffect } from "react"

function TextInputHorizontalTag({
  columnsClass = defaultValues.columnsClass,
  leftClass = defaultValues.leftClass,
  rightClass = defaultValues.rightClass,
  inputClass = defaultValues.inputClass,
  label = defaultValues.label,
  type = defaultValues.type,
  changeEvent = defaultValues.changeEvent,
  formerState = defaultValues.formerState,
  id = defaultValues.id
}) {
  
  useEffect(() => {
    if (formerState !== '') {
      document.getElementById(id).value = formerState;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goUp = () => {
    document.body.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
  });
  };
  
  return (
    <div className={columnsClass}>
      <div className={leftClass}>
        <label><strong>{label}:</strong></label>
      </div>
      <div className={rightClass}>
        <input type={type} onChange={changeEvent} id={id} className={inputClass} onBlur={goUp} />
      </div>
    </div>
  )
}

const emptyChange = () => {}

const defaultValues = {
  columnsClass: 'doubleColumn',
  leftClass: 'leftColumn',
  rightClass: 'rightColumn',
  inputClass: '',
  label: 'Example',
  type: 'text',
  formerState: '',
  changeEvent: emptyChange,
  id: 'defaultId'
}

export default TextInputHorizontalTag